import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  Checkbox,
  FormField,
  Select,
  TextArea,
  TextInput,
} from '../../../components';

const propTypes = {
  edit: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool,
};
const defaultProps = {
  edit: false,
  name: '',
  required: false,
};

function DropdownField({
  edit, name, required,
}) {
  if (edit) {
    return (
      <Card>
        <Card.Title>Dropdown Selection</Card.Title>
        <Card.Block>
          <FormField
            label="Name"
            input={TextInput}
            name="name"
            defaultValue={name}
          />
          <Box height="0.5em" />
          <Checkbox
            label="Required"
            name="required"
            defaultChecked={required}
          />
          <Box height="0.5em" />
          <FormField
            label="Options"
            input={TextArea}
            name="options"
            defaultValue="To,Do"
          />
        </Card.Block>
      </Card>
    );
  }

  return (
    <div>
      <FormField
        label={name}
        input={Select}
        name={name}
        data={[
          { text: 'Props', value: '' },
          { text: 'Should', value: '' },
          { text: 'Provide', value: '' },
          { text: 'This', value: '' },
        ]}
      />
      <Box height="0.5em" />
    </div>
  );
}

DropdownField.propTypes = propTypes;
DropdownField.defaultProps = defaultProps;
export default DropdownField;
